export default __webpack_public_path__ + "static/media/epigro_mobile_3.86490754.png";